<template>
  <div
    v-if="!isDataLoaded"
    class="flex h-screen items-center justify-center"
  >
    <LoaderCircle
      class="animate-spin"
      :size="100"
    />
  </div>
</template>

<script setup lang="ts">
  import { LoaderCircle } from 'lucide-vue-next'
  import { useClientActionStore } from '@/store/clientActionStore'
  import { genericErrorToast } from '@/lib/toasts'
  import { computed, onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  const route = useRoute()
  const router = useRouter()
  const clientActionsStore = useClientActionStore()

  const org_questionnaire_creation_token = computed(
    () => route.params.org_questionnaire_creation_token as string
  )
  const questionnaire_questionnaire_creation_token = computed(
    () => route.params.questionnaire_questionnaire_creation_token as string
  )
  const isDataLoaded = ref(false)

  onMounted(async () => {
    try {
      const response = await clientActionsStore.getQuestionnaireExternalRedirectToken(
        org_questionnaire_creation_token.value,
        questionnaire_questionnaire_creation_token.value
      )
      if (Object.keys(response).length !== 0) {
        await router.push({
          path: `/client/portal/external/questionnaire/${response.short_id}`,
          query: { access_token: response.token }
        })
        isDataLoaded.value = true
      } else {
        genericErrorToast()
      }
    } catch (error) {
      genericErrorToast()
    }
  })
</script>
